const coursePages = [
  {
    slug: "curso-auxiliar-enfermeria-ixtapaluca",
    title: "Curso de Auxiliar de Enfermería en Ixtapaluca",
    metaTitle:
      "Curso de Auxiliar de Enfermería en Ixtapaluca | Fundación Nican",
    metaDescription:
      "Estudia auxiliar de enfermería en Ixtapaluca con Fundación Nican. Aprende atención al paciente, fundamentos clínicos y habilidades para mejorar tu empleabilidad.",
    lead:
      "Prepárate para desarrollar habilidades prácticas en atención al paciente, procedimientos básicos y fundamentos de enfermería con un enfoque humano y profesional.",
    keywords: [
      "curso de auxiliar de enfermería en Ixtapaluca",
      "enfermería Estado de México",
      "formación en salud",
      "Fundación Nican",
    ],
    benefits: [
      "Aprende fundamentos clínicos y atención básica al paciente.",
      "Desarrolla habilidades útiles para hospitales, clínicas y campañas de salud.",
      "Mejora tus oportunidades laborales en el sector salud.",
      "Estudia en una sede cercana para alumnos de Ixtapaluca, Chalco y Valle de Chalco.",
    ],
    sections: [
      {
        heading: "¿Para quién es este curso?",
        text: "Este curso está pensado para personas que desean iniciar una formación en el área de salud, mejorar su perfil laboral o adquirir conocimientos prácticos para apoyar en el cuidado de pacientes.",
      },
      {
        heading: "¿Qué aprenderás?",
        text: "Verás temas como enfermería propedéutica, anatomía, procedimientos de atención al individuo y bases para comprender padecimientos frecuentes.",
      },
    ],
    faqs: [
      {
        question: "¿El curso de auxiliar de enfermería es presencial?",
        answer:
          "Los programas de formación en áreas de salud suelen ser presenciales para facilitar la práctica y el acompañamiento.",
      },
      {
        question: "¿Dónde puedo pedir informes?",
        answer:
          "Puedes solicitar información por WhatsApp al 55 79 11 85 89.",
      },
    ],
  },
  {
    slug: "diplomado-quiropractica-ixtapaluca",
    title: "Diplomado en Quiropráctica en Ixtapaluca",
    metaTitle: "Diplomado en Quiropráctica en Ixtapaluca | Fundación Nican",
    metaDescription:
      "Estudia quiropráctica en Ixtapaluca. Formación profesional en técnicas terapéuticas, rehabilitación física y bienestar corporal con Fundación Nican.",
    lead:
      "Aprende técnicas de quiropráctica, alineación corporal y apoyo terapéutico para desarrollarte profesionalmente en salud y bienestar.",
    keywords: [
      "diplomado en quiropráctica en Ixtapaluca",
      "curso de quiropráctica Estado de México",
      "rehabilitación física",
      "terapias alternativas",
    ],
    benefits: [
      "Desarrolla habilidades en técnicas corporales y terapéuticas.",
      "Fortalece tu perfil para trabajar en bienestar, rehabilitación o autoempleo.",
      "Estudia con enfoque práctico y acompañamiento profesional.",
      "Atiende una demanda creciente de servicios de salud y bienestar.",
    ],
    sections: [
      {
        heading: "Formación enfocada en bienestar",
        text: "El diplomado integra bases de anatomía, osteología, ejercicio terapéutico y técnicas quiroprácticas para apoyar procesos de bienestar físico.",
      },
      {
        heading: "Oportunidad profesional",
        text: "La quiropráctica puede abrir oportunidades para trabajar en centros de rehabilitación, espacios deportivos, consultorios o proyectos de autoempleo.",
      },
    ],
    faqs: [
      {
        question: "¿Necesito experiencia previa?",
        answer:
          "Un asesor puede orientarte según tu perfil y el nivel del programa vigente.",
      },
      {
        question: "¿Dónde se imparte?",
        answer:
          "Fundación Nican se ubica en Ixtapaluca, Estado de México.",
      },
    ],
  },
  {
    slug: "curso-masoterapia-ixtapaluca",
    title: "Curso Profesional de Masoterapia en Ixtapaluca",
    metaTitle: "Curso de Masoterapia en Ixtapaluca | Fundación Nican",
    metaDescription:
      "Conviértete en especialista en masoterapia en Ixtapaluca. Aprende técnicas terapéuticas, rehabilitación muscular y bases para emprender.",
    lead:
      "Capacítate en técnicas de masaje terapéutico y bienestar físico para ofrecer servicios profesionales o iniciar tu propio proyecto.",
    keywords: [
      "curso de masoterapia en Ixtapaluca",
      "masajes terapéuticos",
      "terapias alternativas",
      "autoempleo en bienestar",
    ],
    benefits: [
      "Aprende técnicas como masaje sueco, drenaje linfático, reflexología y shiatsu.",
      "Desarrolla habilidades para ofrecer servicios terapéuticos.",
      "Construye una opción de autoempleo en salud y bienestar.",
      "Recibe formación con enfoque práctico y profesional.",
    ],
    sections: [
      {
        heading: "Una formación útil para emprender",
        text: "La masoterapia permite desarrollar servicios enfocados en relajación, recuperación muscular y bienestar integral.",
      },
      {
        heading: "Aprendizaje práctico",
        text: "El curso combina bases de anatomía con técnicas manuales para que el alumno gane seguridad y criterio profesional.",
      },
    ],
    faqs: [
      {
        question: "¿Puedo iniciar un negocio con este curso?",
        answer:
          "La formación puede ayudarte a adquirir bases para ofrecer servicios de masaje terapéutico y bienestar.",
      },
      {
        question: "¿El curso es para principiantes?",
        answer:
          "Puedes escribir por WhatsApp para confirmar requisitos y el grupo adecuado para tu nivel.",
      },
    ],
  },
  {
    slug: "certificaciones-sep-estado-de-mexico",
    title: "Certificaciones SEP-CONOCER en Estado de México",
    metaTitle:
      "Certificaciones SEP-CONOCER en Estado de México | Fundación Nican",
    metaDescription:
      "Obtén certificaciones laborales SEP-CONOCER con Fundación Nican. Procesos de evaluación para fortalecer tu perfil profesional en Estado de México.",
    lead:
      "Fortalece tu perfil profesional con certificaciones laborales que acreditan competencias y pueden mejorar tus oportunidades de empleo o autoempleo.",
    keywords: [
      "certificaciones SEP Estado de México",
      "certificaciones CONOCER Ixtapaluca",
      "certificación laboral",
      "competencias laborales",
    ],
    benefits: [
      "Acredita competencias laborales ante organismos reconocidos.",
      "Mejora tu perfil para empleadores, clientes o instituciones.",
      "Accede a procesos de alineación y evaluación según el estándar.",
      "Recibe orientación para elegir la certificación adecuada.",
    ],
    sections: [
      {
        heading: "¿Qué certificaciones ofrece Fundación Nican?",
        text: "Trabajamos con estándares como EC0616, EC0076, EC0217.01, EC1375, EC0301 y EC0366, entre otros programas de formación profesional.",
      },
      {
        heading: "Certificación para crecer laboralmente",
        text: "Una certificación puede respaldar lo que sabes hacer, ayudarte a competir mejor y abrir oportunidades en capacitación, salud, bienestar o servicios profesionales.",
      },
    ],
    faqs: [
      {
        question: "¿Qué es una certificación CONOCER?",
        answer:
          "Es un proceso que evalúa y acredita competencias laborales de acuerdo con un estándar.",
      },
      {
        question: "¿Cómo inicio el proceso?",
        answer:
          "Contacta a Fundación Nican por WhatsApp para conocer requisitos, fechas y costos del estándar que te interesa.",
      },
    ],
  },
  {
    slug: "diplomado-podologia-clinica-ixtapaluca",
    title: "Diplomado en Podología Clínica en Ixtapaluca",
    metaTitle:
      "Diplomado en Podología Clínica en Ixtapaluca | Fundación Nican",
    metaDescription:
      "Estudia podología clínica en Ixtapaluca con Fundación Nican. Diplomado presencial de 8 meses con práctica clínica real, pie diabético y patologías del pie.",
    downloadable: "podologia-clinica.pdf",
    lead:
      "Formación presencial teórico-práctica de 8 meses para especializarte en el cuidado integral del pie, diagnóstico de patologías y atención podológica profesional.",
    keywords: [
      "diplomado en podología clínica en Ixtapaluca",
      "curso de podología Estado de México",
      "podología clínica",
      "pie diabético",
      "patologías del pie",
    ],
    benefits: [
      "Aprende anatomía de miembros inferiores, biomecánica y patologías del pie.",
      "Desarrolla criterio para evaluar afecciones como onicomicosis, tiña pedis, onicocriptosis, hiperqueratosis y pie diabético.",
      "Practica técnicas avanzadas como reflexología podal, alta frecuencia, vendaje kinestésico, ventosas y masaje aplicado.",
      "Prepárate para emprender o integrarte al sector salud con tratamientos seguros y profesionales.",
    ],
    sections: [
      {
        heading: "Objetivo del diplomado",
        text: "El diplomado busca formar especialistas con vocación de servicio en el cuidado integral del pie mediante un programa presencial enfocado en diagnóstico, fórmulas magistrales podológicas y práctica clínica real.",
      },
      {
        heading: "¿Qué aprenderás?",
        text: "Estudiarás introducción a la podología, anatomía de miembros inferiores, biomecánica, enfermedades de las uñas, bioseguridad, microbiología, micología, podología terapéutica, farmacología podológica y evaluación integral del paciente con pie diabético.",
      },
      {
        heading: "Prácticas reales",
        text: "El programa contempla práctica clínica con casos como onicomicosis, tiña pedis, onicocriptosis, hiperqueratosis, helomas, VPH y disfunciones biomecánicas del pie.",
      },
    ],
    faqs: [
      {
        question: "¿Cuánto dura el diplomado en podología clínica?",
        answer:
          "El diplomado tiene una duración de 8 meses en modalidad presencial teórico-práctica.",
      },
      {
        question: "¿El diplomado incluye práctica clínica?",
        answer:
          "Sí. El programa está enfocado en práctica clínica real para desarrollar habilidades aplicables en atención podológica.",
      },
      {
        question: "¿Para qué me prepara este diplomado?",
        answer:
          "Te prepara para emprender servicios podológicos o integrarte al sector salud con conocimientos sobre patologías del pie, pie diabético, bioseguridad y técnicas terapéuticas.",
      },
    ],
  },
  {
    slug: "curso-fisioterapia-ixtapaluca",
    title: "Curso de Fisioterapia en Ixtapaluca",
    metaTitle: "Curso de Fisioterapia en Ixtapaluca | Fundación Nican",
    metaDescription:
      "Aprende fisioterapia y rehabilitación física en Ixtapaluca con Fundación Nican. Desarrolla habilidades para ayudar a pacientes y crecer profesionalmente.",
    lead:
      "Desarrolla habilidades prácticas en fisioterapia, rehabilitación física y atención terapéutica para mejorar tu perfil profesional en el sector salud.",
    keywords: [
      "curso fisioterapia ixtapaluca",
      "curso de fisioterapia Estado de México",
      "rehabilitación física",
      "terapias físicas en Ixtapaluca",
    ],
    benefits: [
      "Aprende bases de rehabilitación física y atención terapéutica.",
      "Fortalece tu perfil para trabajar en salud, bienestar o autoempleo.",
      "Atiende una demanda local de servicios físicos en Ixtapaluca y la zona oriente.",
      "Desarrolla habilidades que te permitan generar ingresos ayudando a otros.",
    ],
    sections: [
      {
        heading: "Formación enfocada en salud y movimiento",
        text: "El curso está pensado para personas interesadas en aprender bases de fisioterapia, recuperación física y atención terapéutica con enfoque práctico.",
      },
      {
        heading: "SEO local y oportunidad profesional",
        text: "Ixtapaluca, Chalco y Valle de Chalco tienen una demanda creciente de servicios de rehabilitación, terapias físicas y bienestar corporal.",
      },
    ],
    faqs: [
      {
        question: "¿Dónde puedo estudiar fisioterapia en Ixtapaluca?",
        answer:
          "Puedes solicitar informes en Fundación Nican, ubicada en Ixtapaluca, Estado de México.",
      },
      {
        question: "¿Este curso me ayuda a emprender?",
        answer:
          "Sí. La formación en terapias físicas puede ayudarte a desarrollar servicios profesionales y opciones de autoempleo.",
      },
    ],
  },
  {
    slug: "certificacion-ec0616",
    title: "Certificación EC0616 en Ixtapaluca",
    metaTitle: "Certificación EC0616 en Ixtapaluca | Fundación Nican",
    metaDescription:
      "Certifícate en EC0616 con Fundación Nican. Fortalece tu perfil en auxiliar de enfermería y atención al paciente en Ixtapaluca.",
    downloadable: "EC0616.pdf",
    lead:
      "Acredita tus competencias en funciones de apoyo relacionadas con enfermería y atención al paciente mediante la certificación EC0616.",
    keywords: [
      "certificacion ec0616",
      "certificación EC0616 Ixtapaluca",
      "certificación auxiliar enfermería",
      "certificación laboral CONOCER",
    ],
    benefits: [
      "Respalda tus competencias laborales ante empleadores e instituciones.",
      "Mejora tu perfil en áreas de salud y atención al paciente.",
      "Accede a un proceso de orientación y evaluación en Fundación Nican.",
      "Fortalece tus oportunidades de empleo en Ixtapaluca y Estado de México.",
    ],
    sections: [
      {
        heading: "¿Qué es la certificación EC0616?",
        text: "Es una certificación laboral orientada a competencias relacionadas con apoyo en enfermería y atención al paciente.",
      },
      {
        heading: "¿Por qué certificarte?",
        text: "Una certificación puede ayudarte a demostrar lo que sabes hacer, competir mejor laboralmente y abrir oportunidades en el sector salud.",
      },
    ],
    faqs: [
      {
        question: "¿La EC0616 tiene validez oficial?",
        answer:
          "Sí. Es una certificación relacionada con estándares de competencia laboral reconocidos.",
      },
      {
        question: "¿Cómo inicio mi proceso de certificación EC0616?",
        answer:
          "Contacta a Fundación Nican por WhatsApp para conocer requisitos, fechas y costos vigentes.",
      },
    ],
  },
];

export default coursePages;
